"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgAdjust = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M16.001 12a4.002 4.002 0 01-3.871-2.99c0-.007-2.377-.007-7.131 0-.667.005-1-.329-.999-1.001C4.001 7.336 4.335 7 5.001 7l7.121.018A4.002 4.002 0 0120.001 8a4 4 0 01-4 4zM8 12c1.86 0 3.424 1.27 3.871 2.99 0 .007 2.377.007 7.131 0 .667-.005 1 .329.999 1.001C20 16.664 19.666 17 19 17l-7.121-.018A4.002 4.002 0 014 16a4 4 0 014-4zm8.001-2a2 2 0 100-4 2 2 0 000 4zm-8 8a2 2 0 100-4 2 2 0 000 4z' }))); };
exports.default = SvgAdjust;
//# sourceMappingURL=Adjust.js.map